<script lang="ts" setup>
import { ModalWrapperProps } from "~/components/Filters/Utils/ModalWrapper.props"

withDefaults(defineProps<ModalWrapperProps>(), {
  openFrom: "left"
})

const emit =
  defineEmits<{
    (e: "onSelectAll"): void
    (e: "onDeleteAll"): void
    (e: "onClose"): void
    (e: "onAfterClose"): void
  }>()

const algoliaReset = useAlgoliaReset()
const { scopedId } = useAlgoliaWidgetScope()
</script>

<template>
  <Teleport to="body">
    <FiltersUtilsSlide
      :name="name"
      :open-from="openFrom"
      @onAfterClose="emit('onAfterClose')"
    >
      <AisClearRefinements :id="scopedId('all')">
        <template v-slot="{ canRefine, refine }">
          <FiltersUtilsModalHead
            v-bind="{
              title: header.title,
              action: canRefine ? 'deleteAll' : 'none'
            }"
            @onSelectAll="emit('onSelectAll')"
            @onDeleteAll="
              () => {
                algoliaReset?.()
                refine()
              }
            "
            @onClose="emit('onClose')"
        /></template>
      </AisClearRefinements>

      <slot />
    </FiltersUtilsSlide>
  </Teleport>
</template>
